import { SamplingRequestRejectMotive } from "@/components/common/section-components/requests/sampling-request/SamplingRequestRejectMotive";
import { SolicitudServicioDetail } from "@/services/service-requests.service";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { rowBg, useSamplingRequestRows } from "./sampling-request-rows";

interface Props {
  detail: SolicitudServicioDetail | null;
  cantidadLabel: string;
  cantidadFormatted: string;
  executedLabel: string;
  executedFormatted: string;
  showExecutionInfo: boolean;
  isRejected: boolean;
  isMuestrasUnidad: boolean;
}

export const SamplingRequestMainData = ({
  detail,
  cantidadLabel,
  cantidadFormatted,
  showExecutionInfo,
  executedLabel,
  executedFormatted,
  isRejected,
  isMuestrasUnidad,
}: Props) => {
  const { leftRows, rightRows } = useSamplingRequestRows({
    detail,
    cantidadLabel,
    cantidadFormatted,
    executedLabel,
    executedFormatted,
    showExecutionInfo,
    isMuestrasUnidad,
  });

  return (
    <>
      <Grid templateColumns="repeat(2, 1fr)" gap={18}>
        {/* GRID IZQUIERDO */}
        <GridItem>
          <Flex
            flexDir="column"
            padding="12px"
            height="100%"
            border={`1px solid ${AppColors.WHITE_BORDER_1}`}
            borderRadius="12px"
          >
            <Text
              className="amd-card-title"
              paddingBottom="10px"
              textTransform="uppercase"
              paddingX="24px"
              fontWeight={700}
            >
              Detalle
            </Text>

            <Grid templateColumns="repeat(2, 1fr)" gridAutoRows="50px">
              {leftRows.map(({ label, value }, i) => (
                <>
                  <GridItem
                    key={`left-label-${label}`}
                    paddingX="24px"
                    paddingY="8px"
                    display="flex"
                    alignItems="center"
                    backgroundColor={rowBg(i)}
                  >
                    <Text className="account-title-label">{label}</Text>
                  </GridItem>
                  <GridItem
                    key={`left-value-${label}`}
                    paddingX="24px"
                    paddingY="8px"
                    display="flex"
                    alignItems="center"
                    backgroundColor={rowBg(i)}
                  >
                    {typeof value === "string" || typeof value === "number" ? (
                      <Text className="account-value-label">{value}</Text>
                    ) : (
                      value
                    )}
                  </GridItem>
                </>
              ))}
            </Grid>
          </Flex>
        </GridItem>

        {/* GRID DERECHO */}
        <GridItem>
          <Flex
            flexDir="column"
            padding="12px"
            height="100%"
            border={`1px solid ${AppColors.WHITE_BORDER_1}`}
            borderRadius="12px"
          >
            <Text
              className="amd-card-title"
              paddingBottom="10px"
              textTransform="uppercase"
              paddingX="24px"
              fontWeight={700}
              visibility="hidden"
            >
              -
            </Text>

            <Grid templateColumns="repeat(2, 1fr)" gridAutoRows="50px">
              {rightRows.map(({ label, value }, i) => (
                <>
                  <GridItem
                    key={`right-label-${label}`}
                    paddingX="24px"
                    paddingY="8px"
                    display="flex"
                    alignItems="center"
                    backgroundColor={rowBg(i)}
                  >
                    <Text className="account-title-label">{label}</Text>
                  </GridItem>
                  <GridItem
                    key={`right-value-${label}`}
                    paddingX="24px"
                    paddingY="8px"
                    display="flex"
                    alignItems="center"
                    minW={0}
                    backgroundColor={rowBg(i)}
                  >
                    {typeof value === "string" || typeof value === "number" ? (
                      <Text className="account-value-label">{value}</Text>
                    ) : (
                      value
                    )}
                  </GridItem>
                </>
              ))}
            </Grid>
          </Flex>
        </GridItem>
      </Grid>

      <Flex flexDir="column" gap="12px" paddingTop="10px">
        <Flex alignItems="center" gap="30px">
          <Text fontWeight={700}>Observaciones</Text>
        </Flex>

        <Flex
          flexDir="column"
          padding="12px"
          height="120px"
          overflowY="auto"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
          gap="12px"
        >
          <Text fontSize="14px">
            {String(detail?.detalle ?? "").trim() || "-"}
          </Text>
        </Flex>
      </Flex>

      {isRejected && <SamplingRequestRejectMotive detail={detail} />}
    </>
  );
};
